exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:400px){#paypal-button-container{width:100%;height:100%;max-height:200px}#paypal-button-container .paypal-button-row{height:100%!important;max-height:200px!important}}@media screen and (min-width:400px){#paypal-button-container{width:250px;height:100%;max-height:200px}#paypal-button-container .paypal-button-row{height:100%!important;max-height:200px!important}}", ""]);

// exports
